import { render, staticRenderFns } from "./Cerrado.vue?vue&type=template&id=6d85269d&scoped=true&"
import script from "./Cerrado.vue?vue&type=script&lang=js&"
export * from "./Cerrado.vue?vue&type=script&lang=js&"
import style0 from "./Cerrado.vue?vue&type=style&index=0&id=6d85269d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d85269d",
  null
  
)

export default component.exports